import type { z } from 'zod';

const keysToOmit = [
    'id',
    'objectId',
    'versionedIn',
    'versionedInArtifactTypeGroup',
    'persistableInfo',
    'parentId',
    'parentRelation',
    'systemAnnotations',
    'userAnnotations',
    'resourceType',
] as const;

export const getMutationSchema = <T extends z.ZodRawShape>(schema: z.ZodObject<T>) => {
    const keysSet = new Set(Object.keys(schema.shape));
    const omitSet = new Set(keysToOmit);

    const intersection = Array.from(keysSet.intersection(omitSet));

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return schema
        .omit(Object.fromEntries(intersection.map((key) => [key, true])) as Partial<Record<keyof T, true>>)
        .loose() as unknown as z.ZodObject<Omit<T, (typeof keysToOmit)[number]>>;
};
